import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./theme/theme.css";
// The 2026 surface language, layered over the token sheet above. Order matters:
// it redefines `--surface-2`, `--surface-3` and `--btn-shadow`.
import "./theme/neumorph2026.css";
import App from "./App";
import { initialTheme } from "./hooks/useTheme";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { Store } from "./Store/Store";
import { ThirdwebProvider } from "thirdweb/react";
import { initEip6963 } from "./utils/eip6963";
import { startOutboxFlusher } from "./utils/trackingOutbox";

// Paint the theme before the first frame. Done here rather than in a component
// so a dark-mode reload never flashes the light chrome on the way in.
document.documentElement.setAttribute("data-theme", initialTheme());

// Initialize EIP-6963 wallet discovery before React renders
initEip6963();

// Retry any trade-tracking events that failed to send (durable Coded Estate
// trade attribution for the points leaderboard).
startOutboxFlusher();

// Suppress console logs in production (non-localhost)
if (window.location.hostname !== "localhost") {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <ThirdwebProvider>
    <Provider store={Store}>
      <App />
    </Provider>
  </ThirdwebProvider>
  // </React.StrictMode>
);
//ff
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();